var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitHubEditorAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "github",
    clipPath: "url(#clip0_3546_5758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 10.5C20 4.97917 15.5208 0.5 10 0.5C4.47917 0.5 0 4.97917 0 10.5C0 16.0208 4.47917 20.5 10 20.5C15.5208 20.5 20 16.0208 20 10.5Z",
    fill: "#E7D6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 17.375C13.797 17.375 16.875 14.297 16.875 10.5C16.875 6.70304 13.797 3.625 10 3.625C6.20304 3.625 3.125 6.70304 3.125 10.5C3.125 14.297 6.20304 17.375 10 17.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 16.875C13.5208 16.875 16.375 14.0208 16.375 10.5C16.375 6.97918 13.5208 4.125 10 4.125C6.47918 4.125 3.625 6.97918 3.625 10.5C3.625 14.0208 6.47918 16.875 10 16.875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0042 4.28346C6.6125 4.28346 3.875 7.04596 3.875 10.4585C3.875 13.1876 5.62917 15.5001 8.06667 16.3168C8.37083 16.3793 8.48333 16.1835 8.48333 16.021C8.48333 15.8793 8.475 15.3876 8.475 14.8751C6.77083 15.2418 6.4125 14.1376 6.4125 14.1376C6.1375 13.421 5.73333 13.2376 5.73333 13.2376C5.175 12.8585 5.775 12.8585 5.775 12.8585C6.39583 12.9001 6.72083 13.4918 6.72083 13.4918C7.27083 14.4335 8.15 14.1668 8.50833 14.0043C8.55833 13.6043 8.72083 13.3293 8.89583 13.1751C7.5375 13.0335 6.10417 12.5001 6.10417 10.1293C6.10417 9.4543 6.34583 8.9043 6.73333 8.47096C6.67083 8.3168 6.45833 7.68346 6.79583 6.83346C6.79583 6.83346 7.3125 6.67096 8.47917 7.4668C8.97917 7.33346 9.49583 7.26263 10.0125 7.26263C10.5292 7.26263 11.0583 7.33346 11.5458 7.4668C12.7125 6.67096 13.2292 6.83346 13.2292 6.83346C13.5625 7.68346 13.35 8.3168 13.2917 8.47096C13.6875 8.90013 13.9208 9.4543 13.9208 10.1293C13.9208 12.5001 12.4917 13.0251 11.1208 13.1751C11.3458 13.371 11.5375 13.7376 11.5375 14.321C11.5375 15.1501 11.5292 15.8126 11.5292 16.0168C11.5292 16.1793 11.6417 16.3751 11.9458 16.3126C14.3833 15.496 16.1375 13.1835 16.1375 10.4543C16.1458 7.03763 13.3958 4.2793 10.0167 4.2793L10.0042 4.28346Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3546_5758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHubEditorAction);
export default __webpack_public_path__ + "static/media/GitHubEditorAction.17b4f3bc071b385134959e990dc1811c.svg";
export { ForwardRef as ReactComponent };